@use "../../../../sedestral/sass/mixins/positioning";
@use "../../../../sedestral/sass/extends/boxs";
@use "../../../../sedestral/sass/extends/buttons";
@use "../../../../sedestral/sass/mixins/texts";
@use "../../../../sedestral/sass/icons/icons";

.visualModal {
  background: #00000045;
  z-index: 99999999;

  @include positioning.screen-fixed;
  @include positioning.flex-globally;

  &.helpCenter {
    width: calc(100% - 284px);
    right: 0;
    left: unset;
    transition: width 0.3s ease;

    body[data-navigation="true"] & {
      width: calc(100% - 76px);
    }

    body[data-agent-panel="true"] & {
      width: calc(100% - 284px - 355px);
    }

    body[data-navigation="true"][data-agent-panel="true"] & {
      width: calc(100% - 76px - 355px);
    }


    .box {
      height: 100% !important;
      width: 100% !important;
      padding: 0 !important;
      right: 0 !important;
      left: unset;
      border-radius: 0 !important;
      border-left: 1px solid var(--black-sur);
      position: absolute;
      transition: width 0.3s ease;

      @media screen and (max-width: 480px) {
        width: 100% !important;
      }

      .modalHead {
        position: absolute;
        top: 0;
        width: 100%;
        height: 25px;
        z-index: 2;

        .name {
          display: none;
        }

        .round {
          right: 20px;
          top: 20px;
          background: #ffffff14;
          border: 1px solid #ffffff1f;
          border-radius: 100%;
          position: absolute;
          height: 40px;
          width: 40px;

          &:hover {
            background: var(--black);
          }

          .icon {
            width: 16px;
            height: 16px;
            filter: var(--icon-white);
          }
        }
      }

      .modalContent {
        height: 100% !important;
      }
    }
  }

  // le contenu est lui-même la fenêtre : ni cadre, ni titre, la croix vit dans le contenu
  &.raw {
    .box {
      overflow: visible;
      padding: 0 !important;
      background: transparent;
      border-radius: 0;
      box-shadow: none !important;

      .modalHead {
        display: none;
      }

      .modalContent {
        height: 100%;
      }
    }

    @media screen and (max-width: 768px) {
      .box {
        width: 100% !important;
        max-width: 100% !important;
        border-radius: 0 !important;
      }
    }
  }

  &.noTitle {
    .modalHead {
      position: absolute;
      width: calc(100% - 70px);

      .name {
        display: none;
      }
    }

    .round {
      z-index: 2;
    }
  }

  .box {
    width: 400px;
    overflow: hidden;
    padding: 20px;
    height: calc(100% - 40px);
    position: relative;
    background: var(--white);
    border-radius: 14px;
    box-shadow: var(--shadow-box) !important;

    @include boxs.closable;

    .modalHead {
      display: flex;
      align-items: center;

      .name {
        font-size: 18px;

        @include texts.font("semi-bold");
        @extend .name;
      }

      .round {
        width: 32px;
        height: 32px;
        background: var(--grey-sur);
        margin-left: auto;

        @include buttons.round;
        @include positioning.flex-globally;

        &.CloseButton {
          visibility: visible;
        }

        &:hover {
          background: var(--grey-sur-hover);
        }

        .icon {
          height: 12px;
          width: 12px;

          @include icons.ico("black-close");
        }
      }
    }

    .modalContent {
      position: relative;
      height: calc(100% - 26px);
    }
  }

  &.scrollable {
    .modalContent {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  @media screen and (max-width: 768px) {
    .box {
      width: calc(100% - 40px) !important;
      position: fixed;
      padding: 20px !important;
      bottom: 0;
      border-radius: 14px 14px 0px 0px !important;

      .modalContent {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
    }
  }
}